import React from 'react';
import './styles.scss'

export default props => (
    <svg  onClick={ () => props.setFunction() } xmlns="http://www.w3.org/2000/svg" viewBox="0 0 33.02 79.82"><defs></defs><g id="Warstwa_2" data-name="Warstwa 2"><g id="kroki"><path className={"cls-1 " + ( props.active === 1 ? 'active' : '')} d="M29,78.82H18.12V23.9H1v-10S17.61,13.9,21.68,1H32V79.82" /></g></g></svg>
)